<template>
  <form-section
    :title="$t('NotificationLog_Recipients')"
    :description="totalMessages"
  >
    <rest-list :payload="fetchEndpoint" :outline="false">
      <rest-list-column
        prop="profile_id"
        :title="$t('NotificationLog_Recipients_Profile')"
        :route="profileIdRoute"
        :width="300"
      />

      <rest-list-column
        prop="message_type"
        :title="$t('NotificationLog_Recipients_MessageType')"
        :width="100"
        :formatter="messageTypeFormatter"
      />

      <rest-list-column
        v-if="showDeviceId"
        prop="device_id"
        :title="$t('NotificationLog_Recipients_Device')"
        :route="deviceIdRoute"
        :width="180"
      />

      <rest-list-column
        v-if="showMessageVariant"
        prop="message_variant"
        :title="$t('NotificationLog_Recipients_Variant')"
        :width="100"
      />

      <rest-list-column
        v-if="showMessageLanguage"
        prop="message_language"
        :title="$t('NotificationLog_Recipients_Language')"
        :width="100"
      />

      <rest-list-column
        v-if="showMessageParams"
        prop="message_params"
        :title="$t('NotificationLog_Recipients_MessageParams')"
        :formatter="paramsFormatter"
        :tooltip="true"
        :min-width="160"
      />

      <rest-list-column-enum
        prop="delivery_status"
        :title="$t('NotificationLog_Recipients_Status')"
        :width="160"
        :enum="MessageDeliveryStatusLabel"
      />

      <rest-list-column
        v-if="showError"
        prop="error_message"
        :title="$t('NotificationLog_Recipients_Error')"
        :min-width="200"
      />

      <rest-list-column-boolean
        v-if="showBehaviour && openAvailable"
        prop="open"
        :include-na-label="true"
        :title="$t('NotificationLog_Recipients_Open')"
        :width="120"
      />

      <rest-list-column-boolean
        v-if="showBehaviour && clickAvailable"
        :include-na-label="true"
        prop="click"
        :title="$t('NotificationLog_Recipients_Click')"
        :width="120"
      />

      <rest-list-column-date
        v-if="showBehaviour && openAvailable"
        prop="open_time"
        :title="$t('NotificationLog_Recipients_OpenDate')"
        :width="180"
      />
    </rest-list>
  </form-section>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import {
  MessageTypeEnum,
  MessageTypeLabel
} from '@/common/enum/MessageTypeEnum'
import { MessageDeliveryStatusLabel } from '@/common/enum/MessageDeliveryStatusEnum'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import FormSection from '@/common/components/form/FormSection'

export default {
  name: 'NotificationRecipients',

  components: {
    FormSection,
    RestListColumnEnum,
    RestList,
    RestListColumn,
    RestListColumnBoolean,
    RestListColumnDate
  },

  data() {
    return {
      MessageDeliveryStatusLabel,
      showError: true,
      showBehaviour: true
    }
  },

  props: {
    model: {
      required: true
    }
  },

  computed: {
    totalMessages() {
      return this.$t('NotificationLog_Recipients_TotalCount', {
        count:
          this.model.processing_count +
          this.model.sent_count +
          this.model.error_count
      })
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `actions/${this.$route.query.id}/messages`
      })
    },

    features() {
      return this.$store.state.app.features
    },

    showDeviceId() {
      return (
        this.model.message_type === MessageTypeEnum.PUSH_IOS ||
        this.model.message_type === MessageTypeEnum.PUSH_ANDROID ||
        this.model.message_type === MessageTypeEnum.PUSH_WEB ||
        (this.model.message_type === MessageTypeEnum.IN_APP &&
          this.model.send_mode === 2) ||
        (this.model.message_type === MessageTypeEnum.ON_SITE &&
          this.model.send_mode === 2) ||
        (this.model.message_type === MessageTypeEnum.INBOX &&
          !this.features.inboxProfileOn)
      )
    },

    showMessageVariant() {
      return this.model.campaign ? this.model.campaign.ab : false
    },

    showMessageLanguage() {
      return this.model.campaign
        ? this.model.campaign.languages_multi || this.model.mxa_multi_langauge
        : false
    },

    showMessageParams() {
      return this.$can('UserPersonalData::Read')
    },

    openAvailable() {
      return (
        this.model.message_type === MessageTypeEnum.PUSH_IOS ||
        this.model.message_type === MessageTypeEnum.PUSH_ANDROID ||
        this.model.message_type === MessageTypeEnum.PUSH_WEB ||
        this.model.message_type === MessageTypeEnum.EMAIL ||
        this.model.message_type === MessageTypeEnum.WHATSAPP
      )
    },

    clickAvailable() {
      return (
        this.model.message_type === MessageTypeEnum.IN_APP ||
        this.model.message_type === MessageTypeEnum.ON_SITE ||
        this.model.message_type === MessageTypeEnum.INBOX ||
        this.model.message_type === MessageTypeEnum.EMAIL
      )
    }
  },

  methods: {
    paramsFormatter(value) {
      return value ? JSON.stringify(value) : '-'
    },

    messageTypeFormatter(value) {
      return this.$t(MessageTypeLabel[value])
    },

    profileIdRoute(row) {
      return projectRoute({
        name: 'ProfileOverview',
        query: {
          profile_id: row.profile_id
        }
      })
    },

    deviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: row.device_id
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/notifications-log/components/NotificationRecipients.vue